import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_PROJECT_CARBON_REMOVAL_POOL',
  name: 'Workspace Project Carbon removal pool',
  type: 'PROJECT',
  description: '',
  modules: [],
  fields: [
    { key: 'name', title: 'Name' },
    { key: 'description', title: 'Description' },
    { key: 'color', title: 'Color' },
    { key: 'createdAt', title: 'Date Created' },
    { key: 'updatedAt', title: 'Date Updated' },
  ],
  actions: ['READ', 'CREATE', 'UPDATE', 'DESTROY'],
}

export default scope
